import { useNavigate } from "react-router-dom";
import BgImage from "../../assets/images/BackgroundImage.png";
import star from "../../assets/images/star.png";
import infrastructure from "../../assets/images/infrastructure.png";
import blog1 from "../../assets/images/blog1.png";
import blog2 from "../../assets/images/blog2.png";
import blog3 from "../../assets/images/blog3.png";
import SEO from "../../components/SEO";
import { Link } from "react-router-dom";

const blog = [
    {
        title: "Openmetal endorses CloudVantage",
        description:
            "Top infrastructure company endorses Cloudvantage as Africa's premier hosting provider for infrastructure solutions.",
        image: blog1,
    },
    {
        title: "Openmetal endorses CloudVantage",
        description:
            "Top infrastructure company endorses Cloudvantage as Africa's premier hosting provider for infrastructure solutions.",
        image: blog2,
    },
    {
        title: "Openmetal endorses CloudVantage",
        description:
            "Top infrastructure company endorses Cloudvantage as Africa's premier hosting provider for infrastructure solutions.",
        image: blog3,
    },
];

const Cloud_infrastructure = () => {
    const navigate = useNavigate();

    return (
        <div>
            <SEO
                title="Cloud Infrastructure | Blog | CloudVantage"
                description="Openmetal Endorses CloudVantage as Africa's Premier Hosting Provider for infrastructure solutions."
                keywords="cloud infrastructure, openmetal, cloudvantage, hosting provider, infrastructure solutions"
                author="CloudVantage"
                ogTitle="Cloud Infrastructure | Blog | CloudVantage"
                ogDescription="Openmetal Endorses CloudVantage as Africa's Premier Hosting Provider."
                ogImage="/assets/images/infrastructure.png"
                ogUrl={typeof window !== 'undefined' ? window.location.href : ''}
            />

            <div
                className="bg-cover bg-center h-full items-center justify-center bg-blue-50 dark:bg-[#141D26] min-h-screen"
                //style={{ backgroundImage: `url(${BgImage})` }}
            >
                <div className="p-6 gap-5 flex flex-col items-center justify-center">
                    <div className="text-black dark:text-white flex font-bold justify-center items-center gap-2">
                        Blog <img src={star} alt="star icon" className="w-5 h-5" />
                    </div>
                    <h1 className="text-3xl md:text-4xl w-5/6 font-semibold text-center text-black dark:text-white crimson-font">
                        Openmetal Endorses CloudVantage as Africa's Premier Hosting Provider.
                    </h1>
                    <p className="text-slate-600 dark:text-gray-300 text-center mb-5">October 3, 2025</p>
                </div>
                <div>
                    <img
                        src={infrastructure}
                        alt="Cloud Infrastructure"
                        className="w-5/6 md:w-1/2 mx-auto rounded-lg shadow-lg"
                    />
                </div>
                <div className="w-5/6 mx-auto m-4 space-y-4 text-black dark:text-white text-sm leading-relaxed">
                    <p>
                        non vitae Praesent Nunc urna enim. gravida vel leo. viverra facilisis
                        felis, ex. fringilla non. tortor. lorem. facilisis tincidunt varius
                        ultrices diam in elementum Morbi placerat. urna ex volutpat tincidunt
                        facilisis vitae vitae adipiscing convallis. maximus consectetur dolor
                        non Nunc eget hendrerit fringilla Placerat. sit sapien dignissim, elit
                        faucibus malesuada est. risus amet, ullamcorper Nullam consectetur
                        sodales. vitae nisl. scelerisque sollicitudin.
                    </p>

                    <p>
                        malesuada Cras sit Vestibulum efficitur. ullamcorper turpis urna.
                        urna. scelerisque massa ipsum Donec Morbi lacus, eu commodo vitae at,
                        vitae ipsum luctus hendrerit cursus non. eu turpis volutpat dignissim,
                        vel dignissim, dui malesuada leo. nibh tincidunt viverra placerat
                        Donec commodo urna. odio dignissim, elit elit vel lobortis, hendrerit
                        tincidunt ex. Sapien diam Nunc Sed sed nibh sodales. elit dignissim,
                        sit sollicitudin. eu Sed placerat enim. est. tincidunt id ullamcorper
                        luctus In placerat sit Lorem lobortis, dolor nisi dolor odio lobortis
                    </p>

                    <p>
                        nec placerat facilisis est. volutpat nisl. placerat odio turpis Sed
                        sit Nunc lacus, Cras Lorem Cras viverra tincidunt faucibus sit vel
                        non. est. Nunc vel ipsum sit Nullam est. In Ut Nunc nec id elit odio
                        placerat Nunc venenatis nisl. eu varius amet, sodales. venenatis eget
                        luctus lacus dignissim, leo. non quam lacus elit. elit. non venenatis
                        malesuada felis, Ut placerat. Nam sit Quisque viverra scelerisque
                        Lorem Nam in nulla, adipiscing tincidunt Nunc nisl. orci leo. vel dui
                        Nullam Lorem efficitur. sit Donec elit eu ipsum lacus, eget odio ex
                        vitae leo. eget urna viverra
                    </p>
                </div>

                <div className="flex justify-center">
                    <button
                        onClick={() => navigate("/blog")}
                        className="bg-blue-500 hover:bg-blue-600 dark:bg-primaryBlue dark:hover:bg-primaryBlue/90 text-white font-medium rounded p-3 justify-center mx-auto transition-colors"
                    >
                        Other Posts
                    </button>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 pt-6 mx-auto max-w-6/7 px-4">
                    {blog.map((blogItem, index) => (
                        <div
                            key={index}
                            className="bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition border border-slate-200 dark:border-[#c4c4c432]"
                        >
                            <img src={blogItem.image} className="h-48 object-cover w-full" alt={blogItem.title} />
                            <div className="p-4">
                                <div className="flex items-center gap-2 mb-2 text-sm">
                                    <span className="bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 px-2 py-0.5 rounded text-xs font-semibold">
                                        Cloud Infrastructure
                                    </span>
                                    <span className="font-semibold text-gray-600 dark:text-gray-300">• 5 min read</span>
                                </div>

                                <h3 className="font-bold text-lg mb-1 tracking-wide text-black dark:text-white">
                                    {blogItem.title}
                                </h3>
                                <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">{blogItem.description}</p>

                                <button className="text-blue-500 dark:text-blue-400 font-semibold border border-blue-500 dark:border-blue-400 px-4 py-1 rounded hover:bg-blue-50 dark:hover:bg-blue-900/20 transition">
                                    Read more
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="bg-blue-200 dark:bg-blue-900/20 p-7 text-center rounded justify-center mx-auto w-6/7 mt-7 mb-7">
                    <h3 className="text-3xl font-bold tracking-wide text-black dark:text-white">
                        Never miss a single news
                    </h3>
                    <p className="mt-4 text-gray-700 dark:text-gray-300">
                        Stay informed with all the latest updates and news about our events.
                        Never miss a moment of our exciting and innovative gatherings in the
                        world of technology and beyond.
                    </p>
                    <div className="flex items-center mt-6 bg-white dark:bg-slate-800 shadow-md rounded overflow-hidden w-full md:w-1/2 border border-slate-200 dark:border-[#c4c4c432] justify-between p-2 gap-x-4 mx-auto">
                        <div className="flex w-1/2 md:w-full">
                            <div className="md:flex items-center pl-4 hidden">
                                <img src={star} alt="icon" className="w-5 h-5 opacity-70" />
                            </div>
                            <input
                                type="email"
                                placeholder="Enter your email address"
                                className="flex-grow p-2 md:p-3 text-slate-700 dark:text-white dark:bg-slate-700 placeholder-slate-400 border-none outline-none dark:placeholder-gray-400 focus:outline-none"
                            />
                        </div>
                        <div className="flex items-center gap-4">
                            <button className="bg-blue-500 hover:bg-blue-600 dark:bg-primaryBlue dark:hover:bg-primaryBlue/90 text-white font-medium md:px-6 md:py-3 rounded hidden md:block transition-colors">
                                Subscribe
                            </button>
                            <button className="block md:hidden cursor-pointer">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="30"
                                    height="30"
                                    fill="rgba(15,15,95,1)"
                                    className="dark:fill-blue-400"
                                >
                                    <path d="M1.94607 9.31543C1.42353 9.14125 1.4194 8.86022 1.95682 8.68108L21.043 2.31901C21.5715 2.14285 21.8746 2.43866 21.7265 2.95694L16.2733 22.0432C16.1223 22.5716 15.8177 22.59 15.5944 22.0876L11.9999 14L17.9999 6.00005L9.99992 12L1.94607 9.31543Z"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Cloud_infrastructure;

